import React from 'react';
import GnbExtraBtnPresenter from './GnbExtraBtnPresenter';

const GnbExtraBtnContainer: React.FC = () => {
  return <GnbExtraBtnPresenter />;
};

export default GnbExtraBtnContainer;
